import React, { useCallback } from 'react';
import {
    getBezierPath,
    getSmoothStepPath,
    BaseEdge,
    EdgeLabelRenderer,
    useReactFlow,
    MarkerType
} from '@xyflow/react';

// 自定义边组件（带删除按钮）
const N8NEdge = (props) => {
    const {
        id,
        sourceX,
        sourceY,
        targetX,
        targetY,
        sourcePosition,
        targetPosition,
        data,
        markerEnd,
        selected
    } = props;

    const [edgePath, labelX, labelY] = getSmoothStepPath({
        sourceX,
        sourceY,
        sourcePosition,
        targetX,
        targetY,
        targetPosition
    });

    const { setEdges } = useReactFlow();

    // 删除边逻辑
    const onEdgeDelete = useCallback(() => {
        setEdges(edges => edges.filter(edge => edge.id !== id));
    }, [id, setEdges]);

    return (
        <>
            <BaseEdge
                path={edgePath}
                style={{
                    stroke: selected ? '#4CAF50' : '#94a3b8',
                    strokeWidth: 2
                }}
                markerEnd={markerEnd || { type: MarkerType.ArrowClosed }}
            />
            <EdgeLabelRenderer>
                <div
                    style={{
                        position: 'absolute',
                        transform: `translate(-50%, -50%) translate(${labelX}px,${labelY}px)`,
                        padding: '2px 8px',
                        borderRadius: '4px',
                        pointerEvents: 'all'
                    }}
                    className="nodrag nopan"
                >
                    {data?.label && (
                        <span style={{ marginRight: 8, color: '#475569' }}>
                            {data.label}
                        </span>
                    )}
                    <button
                        onClick={onEdgeDelete}
                        style={{
                            padding: '1px 3px',
                            color: 'white',
                            border: 'none',
                            borderRadius: '4px',
                            background: '#ef4444',
                            cursor: 'pointer'
                        }}
                    >
                        ×
                    </button>
                </div>
            </EdgeLabelRenderer>
        </>
    );
};

export default N8NEdge